import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LeadService } from 'src/app/services/lead.service';
import { Constant } from 'src/app/constant/constant';
import { Subject } from 'rxjs';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'calsoft-lead-retry-history',
  templateUrl: './lead-retry-history.component.html',
  styleUrls: ['./lead-retry-history.component.scss']
})
export class LeadRetryHistoryComponent implements OnInit, AfterViewInit {

  @Input() leadId!: number;

  activeRetry: any;
  activeRetrySteps: any[] = [];
  retrySpinner: boolean = false;
  historySpinner: boolean = false;

  // Pagination & Table variables
  historyDataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['retrySettingId', 'retryCycleNo', 'currentRetryNumber', 'retryStatus', 'createdDate'];
  
  page = Constant.PAGE;
  size = Constant.SIZE;
  sortParam = 'createdDate,Desc';
  totalElements = 0;
  pageList = 0;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  searchQuery: string = '';
  search: string = '';
  filterActive: boolean = false;
  mapperMap = new Map();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private leadService: LeadService, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    if (this.leadId) {
      this.getActiveRetry();
      
      this.mapperMap.set('retrySettingId', 'a.retrySettingId');
      this.mapperMap.set('retryCycleNo', 'a.retryCycleNo');
      this.mapperMap.set('currentRetryNumber', 'a.currentRetryNumber');
      this.mapperMap.set('retryStatus', 'a.retryStatus');
      this.mapperMap.set('createdDate', 'a.createdDate');
      
      this.DetectingRequestType();
    }
  }

  ngAfterViewInit() {
    this.historyDataSource.sort = this.sort;
  }

  getActiveRetry() {
    this.retrySpinner = true;
    this.leadService.getActiveRetry(this.leadId).subscribe(
      (res: any) => {
        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {
          if (res.data) {
            this.activeRetry = res.data;
            this.getRetrySteps(this.activeRetry.leadRetryId);
          } else {
            this.retrySpinner = false;
          }
        } else {
          this.retrySpinner = false;
          this.snackBar.open(res['status_message'] || 'Failed to fetch active retry', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      (err) => {
        this.retrySpinner = false;
        this.snackBar.open('Error occurred while fetching active retry', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  getRetrySteps(leadRetryId: number) {
    this.leadService.getRetrySteps(this.leadId, leadRetryId).subscribe(
      (res: any) => {
        this.retrySpinner = false;
        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {
          if (res.data) {
            this.activeRetrySteps = res.data;
          }
        } else {
          this.snackBar.open(res['status_message'] || 'Failed to fetch retry steps', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      (err) => {
        this.retrySpinner = false;
        this.snackBar.open('Error occurred while fetching retry steps', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  DetectingRequestType() {
    if (!this.filterActive) {
      this.getRetryHistory();
    } else {
      this.filterOption(this.search);
    }
  }

  getRetryHistory() {
    this.historySpinner = true;
    const additionalQuery = `a.leadId:${this.leadId}`;
    this.leadService.searchLeadRetries(null, this.page, this.size, this.sortParam, additionalQuery).subscribe(
      (res: any) => {
        this.historySpinner = false;
        this.historyDataSource = new MatTableDataSource(res['content']);
        this.totalElements = res['numberOfElements'];
        this.historyDataSource.sort = this.sort;
        this.historyDataSource.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeOptions = getPageSize(this.pageList);
      },
      (err) => {
        this.historySpinner = false;
      }
    );
  }

  getUpdate(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }

  sortData(event: any) {
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    if (event.direction) {
      if (event.direction === 'asc') {
        this.sortParam = this.mapperMap.get(event.active);
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction === 'desc') {
        this.sortParam = this.mapperMap.get(event.active);
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.DetectingRequestType();
    } else {
      this.sortParam = 'a.createdDate,Desc';
      this.DetectingRequestType();
    }
  }

  onFilterChange(value: string) {
    if (value === '') {
      this.filterActive = false;
      this.getRetryHistory();
    } else {
      this.page = Constant.PAGE;
      let searchTerm = "a.retryStatus:'" + '*' + value.trim() + '*' + "'";
      this.filterOption(searchTerm);
    }
  }

  filterOption(event: string) {
    this.filterActive = true;
    this.search = event;
    this.historySpinner = true;
    const additionalQuery = `a.leadId:${this.leadId}`;
    
    this.leadService.searchLeadRetries(this.search, this.page, this.size, this.sortParam, additionalQuery).subscribe(
      (res: any) => {
        this.historySpinner = false;
        this.historyDataSource = new MatTableDataSource(res['content']);
        this.totalElements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeOptions = getPageSize(this.pageList);
      },
      (err) => {
        this.historySpinner = false;
      }
    );
  }
}
